import React from 'react'
import VoteButton from './VoteButton';

export default function Vote3(props) {
    const { themeData } = props;

    const handleStatus = () => {
        switch (themeData.win){
            case "none": return (themeData && themeData.type === "end" ? "vote-end" : "");
            case "16cha": return "winner-16cha";
            case "calpis": return "winner-calpis";
            case "same": return "draw";
            default: return "";
        }
    }

    return (<>
        <div className="round round3"></div>
        <div className="vote-title title3"></div>
        <div className="vote-desc">
            <div>烤盤上的牛五花吱吱作響，入口越嚼越香。</div>
            <div>好想喝點甚麼，沖刷掉油膩感哪!哪味會是你的解膩搭檔?</div>
        </div>
        <div className={`vote-bg round3 ${handleStatus()}`}></div>
        <div className="vote-chat-container">
            <div className="vote-chat cha">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#16食穀清香回甘</div>
                        <div className="desc">茶湯入喉補充植系食材，平衡油膩感、也平衡吃太多肉的罪惡感，難道...這就是身心平衡的東方養生奧義嗎?</div>
                    </div>
                    <VoteButton voteType="cha" week="3">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
            <div className="vote-chat calpis">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#清爽酸甜</div>
                        <div className="desc">酸酸甜甜的滋味一口喝下，油膩的味蕾瞬間戀愛了!像回到「可爾必思」起源_內蒙古草原，大口吃肉喝酸奶，清爽又解膩!</div>
                    </div>
                    <VoteButton voteType="calpis" week="3">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
        </div>
    </>)
}